var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-effect"},[_c('div',{staticStyle:{"position":"absolute","z-index":"9999999"},attrs:{"id":"ZoomEmbeddedApp"},on:{"click":_vm.generateSignature}},[_vm._v("\n    Join\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }